import React from 'react';

export function ActionsComponent(props: {
  changeSeriesClickHandler: () => any;
  actions: any;
  redirectClickHandler: () => void;
  statisticString: any;
  showFullDetailLink: boolean;
}) {
  return (
    <div>
      {props.showFullDetailLink && (
        <a
          className="orangelink"
          style={{
            color: 'var(--brand-pink)',
            cursor: 'pointer',
            fontSize: '0.95rem',
          }}
          onClick={props.changeSeriesClickHandler}
        >
          {props.actions}
        </a>
      )}
      <a
        className="link"
        style={{ fontSize: '.95rem', float: 'right' }}
        onClick={props.redirectClickHandler}
      >{`View ${props.statisticString}Individual Surveys`}</a>
    </div>
  );
}
